import { useDevice } from "../../useDevice";
import Box from "../Box";
import type { ListItem } from "../ItemList";
import ItemList from "../ItemList";
import OnboardingLayout from "../OnboardingLayout";
import type { PrivacyItem } from "./types";

type Props = {
	items?: ListItem[];
	onPrimaryPress: () => void;
	cta?: string;
};

const PrivacyScreen = ({
	items = [],
	onPrimaryPress,
	cta = "Continue",
}: Props) => {
	const { isMobile } = useDevice();
	return (
		<OnboardingLayout
			onPrimaryPress={onPrimaryPress}
			primaryActionLabel={cta}
			containerPaddingVertical={0}
		>
			<Box paddingHorizontal={isMobile ? 16 : 0}>
				<ItemList items={items} />
			</Box>
		</OnboardingLayout>
	);
};

export type { PrivacyItem };
export default PrivacyScreen;
